export enum NotificationType
{
    NEW_APPOINTMENT = 'new-appointment',
    CANCELED_APPOINTMENT = 'canceled-appointment'
}
